import React, { useEffect } from "react";
import { Layout, Card, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import AdminDashLayout from "../../../Components/Admin/AdminDashLayout";
import JobForm from "./JobForm";

import {
  createJobPosting,
  updateJobPosting,
  fetchSingleJobPosting,
} from "../../../Store/Slices/Admin/jobPosting/jobPostingThunk";

const JobCreateEdit = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const isEdit = Boolean(id);

  const { singleJob, loading } = useSelector(
    (state) => state.admin.jobPosting
  );

  // Fetch single job if editing
  useEffect(() => {
    if (isEdit) {
      dispatch(fetchSingleJobPosting(id));
    }
  }, [dispatch, id, isEdit]);

  const handleSubmit = async (values) => {
    const payload = {
      ...values,
      formTemplate: values.formTemplate,
    };

    try {
      if (isEdit) {
        await dispatch(updateJobPosting({ id, data: payload })).unwrap();
        message.success("Job updated successfully");
      } else {
        await dispatch(createJobPosting(payload)).unwrap();
        message.success("Job created successfully");
      }

      navigate("/careers");
    } catch (err) {
      message.error("Something went wrong");
    }
  };

  return (
    <Layout>
      <AdminDashLayout>
        <Card title={isEdit ? "Edit Job" : "Create Job"}>
          <JobForm
            onSubmit={handleSubmit}
            loading={loading}
            initialValues={isEdit ? singleJob : null}
          />
        </Card>
      </AdminDashLayout>
    </Layout>
  );
};

export default JobCreateEdit;